import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import {SharedModule} from '../shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const httpTranslateFactory = (http: HttpClient): TranslateLoader => new TranslateHttpLoader(http);

@NgModule({
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MaterialModule,
      SharedModule,
      TranslateModule.forRoot({
         loader: {
           provide: TranslateLoader,
           useFactory: httpTranslateFactory,
           deps: [HttpClient]
         }
      })
   ],
   exports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      SharedModule,
      TranslateModule,
   ],
   declarations: [],
   providers: [],
})
export class AppCommonModule { }
